import cn from "classnames";
import { Text, TextSize, TextType, TextWeight } from '@components/Text';
import { getCurrency } from "@utils/formatValues";
import { formatNumber } from "@utils/formatValues";
import styles from "./AmountBlock.module.scss";

const AmountBlock = ({ value, label, currency, align }: {
  value: number,
  label: React.ReactNode,
  currency?: string,
  align?: string;
}) => {
  return (
    <div className={cn(styles.root, styles[`align-${align}`])}>
      <Text size={TextSize.XS} type={TextType.BLOCK}>
        {label}
      </Text>
      <div className={styles.valueRow}>
        <Text size={TextSize.L} weight={TextWeight.BOLD}>
          {formatNumber(value)}
        </Text>
        <Text size={TextSize.S}>
          {getCurrency(currency ?? "")}
        </Text>
      </div>
    </div>
  )
}

export default AmountBlock;
